<template>
    <app-navbar :logo-url="logo"
                :user="user.loggedInUser"
                :profile-data="profileData"/>
</template>

<script>
    import {UserMixin} from '../Auth/Mixins/UserMixin';
    import * as actions from '../../../Config/ApiUrl';
    import {axiosPost} from "../../../Helpers/AxiosHelper";
    import {mapActions} from "vuex";
    import AppFunction from "../../../../core/helpers/app/AppFunction";

    export default {
        name : 'DashboardNavbar',
        mixins: [UserMixin],
        props: {
            logo: {
                type: String,
                default: AppFunction.getAppUrl('images/icon.png')
            }
        },
        data(){
            return{
                profileData: [
                    {
                        optionName: 'My Profile',
                        optionIcon: 'user',
                        url: actions.MY_PROFILE
                    },
                    {
                        optionName: 'Settings',
                        optionIcon: 'settings',
                        url: actions.APP_SETTINGS
                    },
                    {
                        optionName: 'Logout',
                        optionIcon: 'log-out',
                        url: actions.LOGOUT
                    },
                ]
            }
        },
        created() {
            this.$store.dispatch('getSettings');
            this.$store.dispatch('getUser');
        },
        computed: {
        },

        methods: {
        }
    }
</script>
